import HeaderComponent from './components/header/header.component';
import FooterComponent from './components/footer/footer.component';
import MenuComponent from './components/menu/menu.component';
import HomeComponent from './components/home/home.component';
import civiliteFilter from './filters/civilite.filter';
import typePersonneFilter from './filters/type-personne.filter';
import MentionsLegalesComponent from './components/mentions-legales/mentions-legales.component';
import routerConfig from './routes';

require('./base.scss');

const moduleName = 'dmattnt-base';
angular.module(moduleName, ['ui.router'])
  .component('dmattntHeader', new HeaderComponent())
  .component('dmattntFooter', new FooterComponent())
  .component('dmattntMenu', new MenuComponent())
  .component('dmattntHome', new HomeComponent())
  .component('dmattntMentionsLegales', new MentionsLegalesComponent())
  .filter('labelCivilite', civiliteFilter)
  .filter('labelTypePersonne', typePersonneFilter)
  .config(routerConfig);

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/base/base.module.js